import { createFileRoute } from "@tanstack/react-router";
import BeyondAntidepressants from "@/pages/BeyondAntidepressants";
export const Route = createFileRoute("/when-antidepressants-are-not-enough")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "When Antidepressants Are Not Enough | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "When antidepressants aren’t enough, TMS and SAINT TMS may help. Learn about next steps for treatment-resistant depression in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "When Antidepressants Are Not Enough | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "When antidepressants aren’t enough, TMS and SAINT TMS may help. Learn about next steps for treatment-resistant depression in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/when-antidepressants-are-not-enough",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/when-antidepressants-are-not-enough",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BeyondAntidepressants />;
}
